export default __webpack_public_path__ + "static/token_holder@2x-d54d6587e33820706853b205f39c1910.png";